document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.menu-lvl1-btn').forEach(btn => {
    btn.addEventListener('click', () => {

      const handle = btn.dataset.handle;

      // Alle Overlays schließen
      document.querySelectorAll('.menu-overlay')
        .forEach(o => o.classList.remove('open'));

      // Das richtige Overlay öffnen
      document.getElementById(`overlay-${handle}`)
        .classList.add('open');
    });
  });

  // Schließen
  document.querySelectorAll('.overlay-close').forEach(close => {
    close.addEventListener('click', () => {
      close.closest('.menu-overlay').classList.remove('open');
    });
  });

});